// extracted by mini-css-extract-plugin
module.exports = {"errors":"Errors_errors__1uyr5","textAlignCenter":"Errors_textAlignCenter__1jwvr","error":"Errors_error__1IizP","textAlignLeft":"Errors_textAlignLeft__37F0I"};